import { useLayoutEffect, useState } from "react";

const useScrollPosition = () => {
    const [scroll, setScroll] = useState([0, 0]);

    useLayoutEffect(() => {
        const updateScrollPosition = () => setScroll([window.scrollX, window.scrollY]);

        window.addEventListener("scroll", updateScrollPosition);
        updateScrollPosition();
        return () => window.removeEventListener("scroll", updateScrollPosition);
    }, []);

    return scroll;
};

export default useScrollPosition;
